// payment-api.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { setting } from '../../../../setting';
import { UsblickCommonEnum } from 'app/pages/com.usblick.common/usblick-common-enum';

@Injectable({
  providedIn: 'root'
})
export class PaymentApiService {
  private apiUrl = setting.apiBookingUrl;

  constructor(private http: HttpClient) {}

    /**
   * Método compartido para TODAS las pasarelas
   */
  async savePaymetCreditsCards(payload: any): Promise<any> {
    try {
      const response = await fetch(`${this.apiUrl}paymentCreditCards/create`, {
        method: "POST",
        headers: this.getHeaders(),
        credentials: "include",
        body: JSON.stringify(payload)
    });

    const data = await response.json();
      return data;

    } catch (error: any) {
      console.error('❌ Error en savePaymetCreditsCards:', error);
      throw error;
    }
  }

  /**
   * Método compartido para TODAS las pasarelas
   */
  async createPayment(payload: any): Promise<any> {
    try {
      const response = await fetch(`${this.apiUrl}paymentMasters/create`, {
        method: "POST",
        headers: this.getHeaders(),
        credentials: "include",
        body: JSON.stringify(payload)
    });

    const data = await response.json();
      return data;

    } catch (error: any) {
      console.error('❌ Error en createPayment:', error);
      throw error;
    }
  }

  /**
   * Mercado Pago: clave pública para el SDK web y tarjetas guardadas del cliente.
   * {clientId} = clients.id (cliente del itinerario, de una agencia del usuario).
   * Devuelve el body aunque el status no sea 2xx (p. ej. 404 si el cliente no tiene customer).
   */
  async getMercadoPagoCards(clientId: number): Promise<any> {
    try {
      const response = await fetch(`${this.apiUrl}paymentMasters/mercadopago/get-cards/${clientId}`, {
        method: 'GET',
        headers: this.getHeaders(),
        credentials: 'include'
      });

      return await response.json();

    } catch (error: any) {
      console.error('❌ Error en getMercadoPagoCards:', error);
      throw error;
    }
  }

  private getHeaders() {
    // La sesión viaja en la cookie HttpOnly auth_token; fetch() no pasa por
    // HttpConfigInterceptor, por eso credentials: "include" se pide acá
    // explícitamente en cada llamada. Por el mismo motivo los headers de la API
    // (x-api-user / x-api-key, que agrega el interceptor al resto) van acá a mano.
    return {
      'Content-Type': 'application/json',
      'x-api-user': setting.booking_api_user,
      'x-api-key': setting.booking_api_key
    };
  }

};
